import * as mt from './mutation-types';

import { RootState } from '../types';
import { MetadataState } from './types';
import { ActionContext } from 'vuex';

type MetadataContext = ActionContext<MetadataState, RootState>;

export default {
  [mt.TOGGLE_LABEL_MARKER] ({ commit, dispatch }: MetadataContext) {
    commit(mt.TOGGLE_LABEL_MARKER);
    dispatch(mt.PERSIST_METADATA);
  },
  [mt.PERSIST_METADATA] ( { state }: MetadataContext) {
    try {
      localStorage.setItem('_metadata', JSON.stringify(state));
    } catch {}
  }
};
